import { EntityModalForm } from "./CRUDs/abstracts/mixins/EntityModalForm";
import errors from "./errors";
import { Validator } from "./snippets/Validator";
import { Preloader } from "./Common/Preloader";
import { initializeTaxRates } from "./Common/SettingsGroups/TaxRates";

var Mustache = require('mustache');
import { SaveButton } from "./components/SaveButton";

export default {
    init() {
        this.generateApiToken();
        this.deleteApiTokens();
        this.plan();
        this.changeCard();
        this.changeRouteBySelect();
        this.saveSettings();
        this.sendTestNotify();
        this.initUsagePopup();
        this.initMissedPhone();
        this.createUpdateTax();
        this.changeDataPage();
        this.updateHistory();
        this.initUnlockDesignButton();
        this.stickyElemScroll();

        window.addEventListener('load', this.toggleUnclockButton);
        window.addEventListener('resize', this.toggleUnclockButton);
    },
    generateApiToken() {
        $('body').on('click', '#generate_token', function(e) {
            $('#generate_token').prop('disabled', true);
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/tokens/create',
                data: ({
                    token_name: 'pos_access'
                }),
                success: function (response) {
                    let token = response.token.split('|')[1];
                    $('#token').text(token);
                    $('#delete_tokens').prop('disabled', false);
                    let view = {api_token: token};
                    let template = $('#script_tmpl').html() + "\n</script>";
                    let script = Mustache.render(template, view);
                    $('#script').val(script);
                },
                error: function() {
                    $('#generate_token').prop('disabled', false);
                }
            });
        });
    },
    deleteApiTokens() {
        $('body').on('click', '#delete_tokens', function(e) {
            $('#delete_tokens').prop('disabled', true);
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/tokens/delete',
                success: function () {
                    $('#token').text('');
                    $('#script').val('');
                    $('#generate_token').prop('disabled', false);
                },
                error: function() {
                    $('#delete_tokens').prop('disabled', false);
                }
            });
        });

    },
    plan() {
        $('body').on('click', '#change-plan', function(e) {
            $('#plan-modal').modal('show');
        });

        $('body').on('click', '.select-subscription-plan', function(e) {
            $.ajax({
                type: 'POST',
                url: '/settings/change-billing-plan',
                data: ({
                    plan: $(this).data('plan'),
                }),
                success: function (response) {
                    window.location.replace('/dashboard')
                },
            });
        });
    },

    changeCard() {
        $('body').on('click', '#change-card', function(e) {
            $('#change-card-modal').modal('show');
        });
    },
    changeRouteBySelect() {
        $('select#routeSelectSettings').on('change', function(e) {
            var link = $("option:selected", this).val()
            location.href = link;
        })
    },

    saveSettings() {
        $('body').on('click', 'button.setting-save[data-save]', (e) => {
            let SaveBtn = new SaveButton();
            SaveBtn.button = e.currentTarget; // target the clicked save bar, not the first data-save on the page
            SaveBtn.defaultText = e.currentTarget.getAttribute('data-default-label') || SaveBtn.defaultText;

            $.ajax({
                type: 'POST',
                url: '/settings',
                data: {
                    'organisation_id': $(e.target).data('organisation'),
                    'group': 'cockpit',
                    'settings': {
                        'call_forwarding_phone': $('input[name=call_forwarding_phone]').val(),
                        'call_recording': $('input[name=call_recording]').prop('checked'),
                        'email_in_html_format': $('input[name=email_in_html_format]').prop('checked'),
                        'cockpit_default_subject': $('input[name=cockpit_default_subject]').val()
                    }
                },
                beforeSend: () => {
                    SaveBtn.startLoading();
                },
                success: (response) => {
                    SaveBtn.stopLoading().then(() => {
                        SaveBtn.showSuccess();
                    });
                },
                error: (response) => {
                    SaveBtn.showError();
                }
            });
        });

        $('body').on('click', '#create-org-form .btn-info-save.edit', function(e) {
            e.preventDefault();

            $('form.basic-form').find('input, select').removeAttr('disabled');
            $(this).text('Save');
            $(this).removeClass('edit');
        });
        $('body').on('click', '#settings #create-org-form .btn-info-save:not(.edit)', (e) => {
            e.preventDefault();
            const org_id = $(e.currentTarget).data('org_id');
            const form = $(e.currentTarget).parents('form')[0];
            const data = new FormData(form);

            $.ajax({
                type: 'POST',
                url: `/save-organisation/${org_id}`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                beforeSend: () => {
                    $('.bb-preloader-container').show();
                },
                success: (response) => {
                    console.log(response);
                    if (response.view) {
                        $('.organisation-info-container').html(response.view);
                    }
                    $('.bb-preloader-container').hide();

                },
                error: (response) => {
                    console.log(response);
                    $('.bb-preloader-container').hide();

                }
            });
        });

        /*$('body').on('change', '#settings form.organisation-info-form #timezone', (e) => {
            const org_id = $(e.currentTarget).parents('form').data('org_id');
            $.ajax({
                type: 'POST',
                url: `/save-organisation/${org_id}`,
                data: {
                    'timezone': $(e.currentTarget).val()
                },
                success: (response) => {}
            });
        });*/
    },

    sendTestNotify(){
        $('#send-test-notify').on('click',()=>{
            $.ajax({
                type: 'POST',
                url: '/cockpit/send-test-notify',
                success: (response) => {
                    console.log(response)
                },
                error: (response) => {
                    console.log(response);
                }
            });
        })
    },

    initUsagePopup(){
        $('body').off('click', '.details_info')
        .on('click', '.details_info',  function(ev) {
            let targetId = $(ev.currentTarget).data('target')
            if(!targetId)
                return
            const detailsPopup = $('#'+targetId);
            if(detailsPopup.length){
                const rect = detailsPopup[0].getBoundingClientRect();
                //detailsPopup.css({top: `-${rect.height+10}px`, left: `0`, zIndex:'100'});
                //detailsPopup.addClass('visible');
                detailsPopup.addClass(['show','d-flex']);
            }
        });

        $('body').off('click', '.details-popup .standart-close-btn')
        .on('click', '.details-popup .standart-close-btn', function(ev) {
            const parents = $(ev.currentTarget).parents('.details-popup');
            if(!parents.length)
                return
            parents.removeClass(['show','d-flex'])
            parents.css({zIndex:''})
        });
    },

    initMissedPhone(){
        $('body').off('click', '#missed-phone-org-btno')
        .on('click', '#missed-phone-org-btn',  function(ev) {
            $.ajax({
                url: 'missed-phone',
                method: 'POST',
                dataType: 'json',
                success: function(response) {
                    if (response.success)
                        window.location.replace(window.location.origin+'/cockpit')
                },
            });
        })
    },

    createUpdateTax(){
        initializeTaxRates();
    },

    changeDataPage(){
        // real .bb-pager component: page numbers + ‹ › arrows carry data-next_page.
        // .is-gap (ellipsis) and .active (current page) are inert.
        $('body').on('click', '#settings .bb-pager .bb-pg[data-next_page]', (e) => {
            const el = $(e.currentTarget);
            if (el.hasClass('is-gap') || el.hasClass('active')) return;
            const pager = el.closest('.bb-pager');
            const type = pager.data('type');
            const year = pager.data('year');
            const next_page = el.data('next_page');
            const preloader = new Preloader('data-tables');
            if (type) {
                $.ajax({
                    type:'POST',
                    url: `/settings/get-${type}`,
                    data: {
                        next_page: next_page,
                        year: year
                    },
                    beforeSend: ()=>{
                        preloader.open();
                    },
                    success:(response)=>{
                        $(`.data-container.${type}`).html(response);
                    },
                    complete: () => {
                        preloader.close();
                    }
                });
            }
        })
    },

    updateHistory(){
        $('body').on('change', '#settings .select-history-year', function(e) {
            e.preventDefault();
            const year = $(this).val();
            const preloader = new Preloader('data-tables');
            $.ajax({
                type:'POST',
                url: `/settings/get-payment-history`,
                data: {
                    next_page: 1,
                    year: year
                },
                beforeSend: () => {
                    preloader.open();
                },
                success:(response)=>{
                    $(`.data-container.payment-history`).html(response);
                },
                error: (response)=> {
                    if (response.status == 405) {
                        $(e.currentTarget).removeClass('active');
                    }
                },
                complete: () => {
                    preloader.close();
                }
            });
        });
        $('body').on('change', '#settings .select-usage-month', function(e) {
            e.preventDefault();
            const month = $(this).val();
            const preloader = new Preloader('data-tables');
            $.ajax({
                type:'POST',
                url: `/settings/get-usage-history`,
                data: {
                    next_page: 1,
                    year: month
                },
                beforeSend: () => {
                    preloader.open();
                },
                success:(response)=>{
                    $(`.data-container.usage-history`).html(response);
                },
                error: (response)=> {
                    if (response.status == 405) {
                        $(e.currentTarget).removeClass('active');
                    }
                },
                complete: () => {
                    preloader.close();
                }
            });
        });
        $('body').on('change', '#settings .select-monthly-bill-month', function(e) {
            e.preventDefault();
            const month = $(this).val();
            const preloader = new Preloader('data-tables');
            $.ajax({
                type:'POST',
                url: `/settings/get-monthly-bill`,
                data: {
                    next_page: 1,
                    year: month
                },
                beforeSend: () => {
                    preloader.open();
                },
                success:(response)=>{
                    $(`.data-container.monthly-bill`).html(response);
                },
                error: (response)=> {
                    if (response.status == 405) {
                        $(e.currentTarget).removeClass('active');
                    }
                },
                complete: () => {
                    preloader.close();
                }
            });
        });
    },

    initUnlockDesignButton() {
        $('body').on('click', '.unlock-design-button', function() {
            if ($(this).hasClass('opened')) {
                $(this).removeClass('opened');
                $(".help-modal-window.unlock-design-message").hide();
            } else {
                $(this).addClass('opened');
                $(".help-modal-window.unlock-design-message").show();

                let posY = $(this).offset().top - $(".help-modal-window.unlock-design-message").height() - 130;
                let posX = $(this).offset().left - 130;
                if ($(".navbar-vertical-left").hasClass('opened')) posX -= 110;
                
                $(".help-modal-window.unlock-design-message").css({left: posX, top: posY});
            }
        });
    },

    toggleUnclockButton() {
        let currentWindowWith = window.innerWidth;

        if ($(".navbar-vertical-left").hasClass('opened')) {
            var maxWindowWidth = 1652;
            var maxWindowWithForColumnBlock = 1170;
        } else {
            var maxWindowWidth = 1580;
            var maxWindowWithForColumnBlock = 1070;
        }

        if (currentWindowWith < maxWindowWidth) {
            $(".integration-unlock-design").css('flex-direction', 'row');
            $(".unlock-design-text").css('display', 'none');
            $(".unlock-design-button").css('display', 'flex');
        } else {
            $(".integration-unlock-design").css('flex-direction', 'column');
            $(".unlock-design-text").css('display', 'inline-block');
            $(".unlock-design-button").css('display', 'none');            
        }

        if (currentWindowWith < maxWindowWithForColumnBlock) {
            $(".integration-unlock-design").css('flex-direction', 'column');
            $(".unlock-design-button").css('margin-left', '0px !important');
        } else {
            $(".unlock-design-button").css('margin-left', '0.5rem !important');
        }
    },

    stickyElemScroll(){
        if(!['/settings/business', '/settings/cockpit'].includes(location.pathname)) 
            return
        $(document).on('filter_complete',(e)=>{
            let stickyElement = $('.sticky-elem');
            let container = stickyElement.parent();
            let originalOffset = stickyElement.offset();
            let windowHeight = $(window).height(); // Высота viewport
            let elementHeight = stickyElement.outerHeight(); //
            let bottomOfElement = originalOffset.top + elementHeight;
            let baseWindowWidth = $(window).width();
            let baseElementWidth = stickyElement.outerWidth();
            let isFixed = false;

            const stickyFunc = ()=>{
                let scrollTop = $(window).scrollTop();
                if (scrollTop + windowHeight < bottomOfElement && !isFixed) {
                    let voidElem = $(document.createElement('div'));
                    voidElem.addClass('sticky-void')
                    voidElem.css('height', `${stickyElement.outerHeight()}px`)
                            .css('width', `100%`)
                    stickyElement.css('height', `${stickyElement.outerHeight()}px`)
                                .css('width', `${stickyElement.outerWidth()}px`)
                                .css('left', originalOffset.left)
                                .css('background-color', 'white')
                                .css('border-top', '1px solid #D2D5DA')
                    stickyElement.addClass('sticky-elem-active').appendTo('body');
                    voidElem.appendTo(container)
                    isFixed = true;
                } else if (scrollTop + windowHeight >= bottomOfElement && isFixed) {
                    stickyElement.removeAttr('style')
                    stickyElement.removeClass('sticky-elem-active').appendTo(container);
                    $('.sticky-void').remove()
                    isFixed = false;
                }
            }

            stickyFunc()
            $(window).on('scroll', stickyFunc);
            $(window).on('resize',()=>{
                if(stickyElement.hasClass('sticky-elem-active')){
                    let offsetWidth = $(window).width() - baseWindowWidth
                    stickyElement.css('width', `${(baseElementWidth + offsetWidth)}px`)        
                }
            })
        });
    }
}
